import { usePartnerPatchProofreadEventApi } from 'api/partner/proofread_event';
import { useDeleteAttachmentsApi } from 'api/shared/attachments';
import { DisplayAttachmentsContainer } from 'components/shared/display_attachments_container';
import { FilesInput } from 'components/shared/form/input';
import Modal, { ModalSet } from 'components/shared/modal';
import ThemedButton from 'components/shared/themed_button';
import { GlobalStateContext } from 'contexts/global_state_context';
import { ProofreadEvent, ProofreadEventForm } from 'entities/proofread_event';
import { ProofreadEventAttachment } from 'entities/proofread_event_attachments';
import { useForm } from 'rac';
import React, { useContext, useEffect } from 'react';
import { useEffectSkipFirst } from 'utils/hooks';
import { ProofreadEventViewModel } from 'view_models/proofread_event';

type ApprovedResultEventFormDialogProps = {
  modalSet: ModalSet<ProofreadEvent>;
  isPlanForLaboratory: boolean;
  onComplete: (event: ProofreadEvent) => void;
};
export const CompletedEventFormDialog = (props: ApprovedResultEventFormDialogProps) => {
  const globalState = useContext(GlobalStateContext);
  const eventVm = new ProofreadEventViewModel(props.modalSet.item);
  const patchForm = useForm<ProofreadEventForm>(props.modalSet.item);
  const patchApi = usePartnerPatchProofreadEventApi(patchForm);
  const deleteFileApi = useDeleteAttachmentsApi('dealer_user', 'proofread_events');

  const handleClickAddFileButton = () => {
    patchApi.execute();
  };

  const handleClickRemove = (a: ProofreadEventAttachment) => {
    globalState.confirm(`添付ファイル ${a.name} を削除しますか？ この操作は取り消せません`, (event) => {
      if (event === 'ok') {
        deleteFileApi.execute(props.modalSet.item.id!, a.id!);
      }
    });
  };

  useEffect(() => {
    patchForm.set(props.modalSet.item);
  }, [props.modalSet.item]);

  useEffectSkipFirst(() => {
    if (!patchApi.isSuccess()) return;
    props.onComplete(patchApi.response.proofreadEvent);
  }, [patchApi.loading]);

  useEffectSkipFirst(() => {
    globalState.setLoading(deleteFileApi.loading);
    if (deleteFileApi.isSuccess()) {
      props.onComplete(patchApi.response.proofreadEvent);
    }
  }, [deleteFileApi.loading]);

  return (
    <Modal
      modalId="event-planning-form"
      modalState={props.modalSet.modalState}
      title="校正結果確認"
      subTitle={eventVm.getInstrumentName()}
      footer={
        <>
          <ThemedButton color="secondary" onClick={props.modalSet.closeModal}>
            閉じる
          </ThemedButton>
          <ThemedButton color="primary" onClick={handleClickAddFileButton}>
            ファイルの登録
          </ThemedButton>
        </>
      }
    >
      {props.isPlanForLaboratory && (
        <>
          <div>
            <label>計画時メモ</label>
            <p style={{ paddingLeft: 12, margin: '6px 0' }}>{props.modalSet.item.noteOnPlan || 'なし'}</p>
          </div>
          <DisplayAttachmentsContainer
            label="計画時添付ファイル"
            attachments={props.modalSet.item.attachments}
            kind="plan"
          />
        </>
      )}

      <div style={{ marginTop: 12 }}>
        <label>結果入力時メモ</label>
        <p style={{ paddingLeft: 12, margin: '6px 0' }}>{props.modalSet.item.noteOnDealerResult || 'なし'}</p>
      </div>
      <DisplayAttachmentsContainer
        label="結果入力時添付ファイル"
        attachments={props.modalSet.item.attachments}
        kind="partner"
      />
      <div style={{ marginTop: 12 }}>
        <DisplayAttachmentsContainer
          label="校正完了後の追加ファイル"
          attachments={props.modalSet.item.attachments}
          kind="partner_complete"
          onClickRemove={handleClickRemove}
        />
        <FilesInput form={patchForm} attr="attachmentsAttributes" apiError={patchApi.apiError} />
      </div>
    </Modal>
  );
};
